import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ReactLenis from "lenis/react";
import Landing from "@/pages/Landing";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "APEX — Root Canal & Aesthetic Dentistry · Edamuttam";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
      <div className="min-h-screen bg-porcelain text-ink font-sans antialiased" data-testid="app-root">
        <div className="grain-overlay" aria-hidden="true" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="bottom-center" />
      </div>
    </ReactLenis>
  );
}

export default App;
